<template>
  <div>
    <p v-if="errorMessage">
      {{ errorMessage }}<br>
      Please try again later.
    </p>
    <p v-if="ticketSaleStartFromServer">
      Ticket sale starts at {{ ticketSaleStartFromServer.toLocaleString() }}.
    </p>
  </div>
</template>

<script>
const axios = require('axios');
export default {
  props: {
    ticketShopId: {
      type: String
    }
  },
  data() {
    return {
      errorMessage: null,
      ticketSaleStartFromServer: null,
    }
  },
  mounted() {
    axios.get(`${process.env.VUE_APP_API}/tickets/availability/${this.ticketShopId}`)
      .then(response => {
        if (!response.data) {
          this.errorMessage = "An error ocurred.";
          return;
        }

        if (response.data.code !== 200) {
          this.errorMessage = `Error Code ${response.data.code}: ${response.data.msg}`;
          return;
        }

        window.location = response.data.ticketUrl;
      })
      .catch(err => {
        if (err.response && err.response.data) {
          this.errorMessage = `Error Code ${err.response.data.code}: ${err.response.data.msg}`;

          if (err.response.data.ticketSaleStart) {
            this.ticketSaleStartFromServer = new Date(err.response.data.ticketSaleStart)
          }
        } else {
          this.errorMessage = ` ${err}`;
        }
      })
  }
}
</script>
